import { Service } from '@roc/feature-app-core';
import { CreditPullTierSettings } from '../types/creditPullTiersTypes';

const url = {
  GET_ALL_TIERS: '/api/v1/lender/creditPullTiers/getAllTiers',
  BULK_UPDATE_TIERS: '/api/v1/lender/creditPullTiers/bulkUpdateTiers',
  GET_LENDERS_TIER_ASSIGNMENT: '/api/v1/lender/creditPullTiers/getLendersTierAssignment',
  GET_LENDER_DETAIL: (lenderId: number) => `/api/v1/lender/${lenderId}/creditPullTiers/getLenderDetail`,
  PATCH_LENDER_CREDIT_PULL_TIER: (lenderId: number) => `/api/v1/lender/${lenderId}/creditPullTiers/updateLenderTier`,
};

export class CreditPullTiersService extends Service {
  getAllTiers() {
    return this.get(url.GET_ALL_TIERS);
  }

  bulkUpdateTiers(tiers: CreditPullTierSettings[]) {
    return this.patch(url.BULK_UPDATE_TIERS, tiers);
  }

  getLendersTierAssignment(page: number, pageSize: number, sortBy: string, sortDir: string, filters: Record<string, unknown>) {
    return this.get(url.GET_LENDERS_TIER_ASSIGNMENT, { page, pageSize, sortBy, sortDir, filters });
  }

  getLenderDetail(lenderId: number) {
    return this.get(url.GET_LENDER_DETAIL(lenderId));
  }

  patchLenderCreditPullTier(lenderId: number, creditPullTier: string) {
    return this.patch(url.PATCH_LENDER_CREDIT_PULL_TIER(lenderId), { creditPullTier });
  }
}
